// 德语

export default {
  t1: 'Fertig',
  t5: 'Zahlen',
  t6: 'Verknüpfen und autorisieren',
}
